module.exports = __webpack_public_path__ + "static/reason-1-736e07519d9071a662f90b676384f123.svg";